import { put, takeLatest, all, select, call, fork, cancelled } from 'redux-saga/effects';
import LowerFunnelSection from './VerticalProgress.json'
import { delay } from 'redux-saga';


function* getLowerFunnelSection(){
  try{
    yield put({type:'LOWER_FUNNEL_LOADER',data:true})
    // yield delay(2000)
    const response = {data:LowerFunnelSection}
    yield put({type:'LOWER_FUNNEL_SECTIONS',data:response.data})
  }catch(e){
    yield put({type:'LOWER_FUNNEL_LOADER',data:false})
  }finally{
    yield put({type:'LOWER_FUNNEL_LOADER',data:false})
  }
}




export function* lowerFunnelSaga() {
  yield takeLatest('GET_LOWER_FUNNEL_SECTIONS',getLowerFunnelSection)
}


